import http from 'util/http'
/**
 * 获取banner，默认是1，参数如下
 * - 1 网站首页
 * - 5000105 藏经阁首页
 * - 5000106 专题栏首页
 * @param {number} type 类型
 */
export function getHomeBannerList(type?: 1 | 5000105 | 5000106 | 5000107) {
  return http.get('/newxyrj/public/banner/list', {
    module: type,
  })
}
